import Form from "./Form";
import barba from "@barba/core";
const ENDPOINT = "/wp-json/api/v1/form-post";
class ContactForm extends Form {
    constructor(form) {
        super(form);
        this.removeEventListeners();
        this.addEventListeners();
        this.inputList;
    }
    addEventListeners() {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }
    removeEventListeners() {
        this.form.removeEventListener("submit", this.handleSubmit.bind(this));
    }
    handleSubmit(event) {
        event.preventDefault();
        const button = this.form.querySelector(".submit");
        const referrer = window.sessionStorage.getItem("referrer");
        if (this.validate()) {
            this.form.classList.remove("was-validated");
            this.formatInputData();
            button.disabled = true;
            button.classList.add("btn_loading");
            window.gtag("event", "contact_form", {
                path: window.location.pathname,
                referrer: referrer,
            });
            fetch(ENDPOINT, {
                method: "POST",
                body: JSON.stringify(Object.assign(Object.assign({}, this.formdata), { page: window.location.href })),
                headers: { "Content-Type": "application/json" },
            })
                .catch((error) => console.error(error))
                .finally(() => {
                button.classList.remove("btn_loading");
                button.classList.add("btn_success");
                setTimeout(() => {
                    button.disabled = false;
                    this.form.reset();
                }, 1000);
                setTimeout(() => {
                    button.classList.remove("btn_success");
                }, 1000);
                if (document.documentElement.lang === "en-GB") {
                    barba.go("/thank-you");
                }
                else {
                    barba.go("/sv/tack-sida");
                }
            });
        }
    }
}
export const initContactForms = () => document
    .querySelectorAll(".oim-contact-form")
    .forEach((form) => new ContactForm(form));
